<template>
  <RevStickyBar class="block md:hidden" :visible="showBar">
    <div class="flex items-center">
      <div class="grow">
        <Price
          :flash-sales-discount
          :mobile-plan="selectedMobilePlan"
          :price
          :product
          :selected-offer
        />
        <PointsSection
          v-if="price && !showPointsSection"
          class="mt-4"
          :only-paypay="true"
          :price
        />
      </div>
      <RevButton
        class="mood-tangaroa ml-8 grow"
        data-qa="product-page-buy-button-sticky-bar"
        variant="primary"
        @click="onAddToCart"
      >
        {{ i18n(translations.addToCart) }}
      </RevButton>
    </div>
  </RevStickyBar>
</template>

<script lang="ts" setup>
// fixme: duplicated code due to Japan improved PP
import { computed } from 'vue'

import type { Price as PriceType } from '@backmarket/http-api'
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevStickyBar } from '@ds/components/StickyBar'

import { shouldShowPointsSection } from '~/scopes/product/pages/Product-JP/utils/shouldShowPointsSection'
import { useAddToCart } from '~/scopes/product-core/components/containers/ContainerAddToCart/composables/useAddToCart/useAddToCart'
import translations from '~/scopes/product-core/components/presentationals/StickyBarBottom/StickyBarBottom.translations'
import { useProductTracking } from '~/scopes/product-core/composables/useFetch/useFetchProductTracking/composables/useProductTracking/useProductTracking'
import Price from '~/scopes/product-core/pages/ProductDetailPage/jp/components/containers/JPContainerPrice/components/Price/Price.vue'

import PointsSection from '../PointsSection/PointsSection.vue'

const i18n = useI18n()

const props = withDefaults(
  defineProps<{
    selectedOffer: NonNullable<GetPickersResponse['selectedOffer']>
    price: PriceType
    product: GetProductResponse
    selectedMobilePlan?: MobilePlanOffer
    tracking: ReturnType<typeof useProductTracking>
    showBar?: boolean
  }>(),
  {
    selectedMobilePlan: undefined,
    showBar: false,
  },
)

const { addToCart } = useAddToCart()

const flashSalesDiscount = computed(
  () =>
    props.product.promoCodes.find((promoCode) => promoCode.isFlashSale)
      ?.discountValue,
)

// We display the points section if the product does not have a discount / priceWhenNew
const showPointsSection = computed(() =>
  shouldShowPointsSection(props.selectedOffer, props.product),
)

function onAddToCart() {
  addToCart({
    listingId: props.selectedOffer.offerLegacyId,
    listingPublicId: props.selectedOffer.offerId,
    tracking: {
      ...props.tracking.product.value,
      list: 'header',
      campaign_id: props.selectedOffer.campaignId,
      population_id: props.selectedOffer.populationId,
    },
    partnerPromoCodes: props.product.includedServiceOffers.partnerPromoCodes,
    isTradeInEligible: props.product.isTradeInEligible,
  })
}
</script>
